/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  ComputeError,
  ComputeError$inboundSchema,
  ComputeError$Outbound,
  ComputeError$outboundSchema,
} from "./computeerror.js";

/**
 * API error
 */
export type ComputeErrorEnvelope = {
  error: ComputeError;
};

/** @internal */
export const ComputeErrorEnvelope$inboundSchema: z.ZodType<
  ComputeErrorEnvelope,
  z.ZodTypeDef,
  unknown
> = z.object({
  error: ComputeError$inboundSchema,
});
/** @internal */
export type ComputeErrorEnvelope$Outbound = {
  error: ComputeError$Outbound;
};

/** @internal */
export const ComputeErrorEnvelope$outboundSchema: z.ZodType<
  ComputeErrorEnvelope$Outbound,
  z.ZodTypeDef,
  ComputeErrorEnvelope
> = z.object({
  error: ComputeError$outboundSchema,
});

export function computeErrorEnvelopeToJSON(
  computeErrorEnvelope: ComputeErrorEnvelope,
): string {
  return JSON.stringify(
    ComputeErrorEnvelope$outboundSchema.parse(computeErrorEnvelope),
  );
}
export function computeErrorEnvelopeFromJSON(
  jsonString: string,
): SafeParseResult<ComputeErrorEnvelope, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ComputeErrorEnvelope$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ComputeErrorEnvelope' from JSON`,
  );
}
